import React, { Component } from 'react';
import './styles.css';

export default class Card extends Component {
  render() {
    return (
      <div className="card">
        { this.props.children }
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/Card/Card.js